import { asToken } from './sessionDocument'
import {
  createImpersonationRestoreStore,
  type ImpersonationRestoreStore,
} from 'src/modules/UserImpersonation/restore/impersonationRestoreStore'
import {
  createStaffHandoffStore,
  type StaffHandoffStore,
} from 'src/modules/UserImpersonation/restore/staffHandoffStore'

export async function readFuelloxAuthToken (
  getSqliteToken: () => Promise<unknown>,
  handoff: StaffHandoffStore = createStaffHandoffStore(),
  restoreStore: ImpersonationRestoreStore = createImpersonationRestoreStore(),
): Promise<string> {
  const overlay = await handoff.read()
  if (overlay !== null) {
    return overlay.token
  }
  const sqlite = asToken(await getSqliteToken())
  if (sqlite !== '') {
    return sqlite
  }
  const restore = await restoreStore.read()
  if (restore !== null) {
    return restore.staffToken
  }
  return ''
}
